import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnderwear = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.375 5.64624H2.625C2.27954 5.64624 2 5.92578 2 6.27124V11.3433C1.99817 12.5859 2.92529 13.6498 4.18079 13.8207C6.90723 14.0819 9.09778 16.1559 9.50733 18.8646C9.5531 19.1698 9.81617 19.3956 10.125 19.3956H13.875C14.1838 19.3956 14.4463 19.1698 14.4927 18.8646C14.9028 16.1559 17.0928 14.0819 19.843 13.817C21.0747 13.6498 22.0012 12.5859 22 11.3439V6.27124C22 5.92578 21.7205 5.64624 21.375 5.64624ZM20.75 6.89624V8.14624H3.25V6.89624H20.75ZM19.699 12.5762C16.5825 12.8746 14.0447 15.1329 13.3574 18.1456H10.6426C9.95533 15.1329 7.41871 12.8746 4.32484 12.5786C3.71143 12.495 3.24939 11.9646 3.25 11.3439V9.39624H20.75V11.3445C20.7512 11.9646 20.2886 12.495 19.699 12.5762Z",
		fill: "currentColor"
	})
});
export default SvgUnderwear;
